import _ from "lodash";
import { Mixpanel } from ".././utils/mixpanel";
import { removeToken ,removeRedirectURL} from ".././utils/getToken";

const logout = (config) => {
  let login_TYPE = config.LOGIN_TYPE;
  let origin = _.get(window, "location.origin");
  if (login_TYPE === "amplify") {
    Mixpanel.reset();
    removeToken();
    removeRedirectURL()
    window.location.href = `${config.AUTH_URL}/logout`;
  } else if (login_TYPE === "cognito") {
    let base_uri = config.AUTH_URL;
    let client_id = config.CLIENT_ID;
    let redirect_uri = `${origin}/auth`;
    let response_type = "code";
    if (base_uri && client_id) {
      removeToken();
      removeRedirectURL()
      window.location.href = `${base_uri}/logout?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}`;
    }
  }
};
export default logout;

